import NextLink from 'next/link'
import PropTypes from 'prop-types'
import ArrowRightIcon from '@heroicons/react/24/solid/ArrowRightIcon'
import {
  Box,
  Button,
  Card,
  CardActions,
  CardHeader,
  Chip,
  Divider,
  Skeleton,
  SvgIcon,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material'
import { breedLabel } from 'src/utils/breed-labels'

const STATUS_LABELS = {
  paid: { label: '支払済', color: 'success' },
  pending: { label: '未決済', color: 'warning' },
  cancelled: { label: 'キャンセル', color: 'default' },
  failed: { label: '失敗', color: 'error' },
}

const formatDateTime = (value) => {
  if (!value) return '-'
  const d = new Date(value)
  if (Number.isNaN(d.getTime())) return '-'
  return d.toLocaleString('ja-JP', { dateStyle: 'short', timeStyle: 'short' })
}

export const PatternLatestOrders = (props) => {
  const { loading = false, orders = [] } = props

  return (
    <Card sx={{ height: '100%' }}>
      <CardHeader title="最新の型紙注文" />
      <Box sx={{ minWidth: 720, overflowX: 'auto' }}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>注文ID</TableCell>
              <TableCell>顧客</TableCell>
              <TableCell>犬名 / 犬種</TableCell>
              <TableCell align="right">金額</TableCell>
              <TableCell>ステータス</TableCell>
              <TableCell align="right">DL</TableCell>
              <TableCell>注文日時</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {loading &&
              [...Array(5)].map((_, i) => (
                <TableRow key={i}>
                  <TableCell colSpan={7}>
                    <Skeleton height={28} />
                  </TableCell>
                </TableRow>
              ))}

            {!loading && orders.length === 0 && (
              <TableRow>
                <TableCell colSpan={7}>
                  <Typography color="text.secondary" variant="body2" sx={{ py: 2 }}>
                    注文がありません
                  </Typography>
                </TableCell>
              </TableRow>
            )}

            {!loading &&
              orders.map((order) => {
                const status = STATUS_LABELS[order.status] ?? { label: order.status ?? '-', color: 'default' }

                return (
                  <TableRow hover key={order.orderId}>
                    <TableCell>{order.orderId}</TableCell>
                    <TableCell>{order.customerName ?? order.customerEmail ?? '-'}</TableCell>
                    <TableCell>
                      {order.dogName ?? '-'}
                      {order.breedId && (
                        <Typography color="text.secondary" variant="caption" display="block">
                          {breedLabel(order.breedId)}
                        </Typography>
                      )}
                    </TableCell>
                    <TableCell align="right">{`¥${Number(order.amount ?? 0).toLocaleString()}`}</TableCell>
                    <TableCell>
                      <Chip color={status.color} label={status.label} size="small" />
                    </TableCell>
                    <TableCell align="right">{order.downloadCount ?? 0}</TableCell>
                    <TableCell>{formatDateTime(order.createdAt)}</TableCell>
                  </TableRow>
                )
              })}
          </TableBody>
        </Table>
      </Box>
      <Divider />
      <CardActions sx={{ justifyContent: 'flex-end' }}>
        <Button
          component={NextLink}
          href="/orders?tab=pattern"
          color="inherit"
          endIcon={
            <SvgIcon fontSize="small">
              <ArrowRightIcon />
            </SvgIcon>
          }
          size="small"
        >
          すべての型紙注文を見る
        </Button>
      </CardActions>
    </Card>
  )
}

PatternLatestOrders.propTypes = {
  loading: PropTypes.bool,
  orders: PropTypes.array,
}
